<!-- 商品c等级 -->
<template>
    <div>
        <div class="form-main">
            <el-form :model="formData" :rules="rules" ref="formData" label-width="120px" class="formData">
                <el-form-item label="属性名称" prop="SizeName">
                    <el-input v-model="formData.SizeName"></el-input>
                </el-form-item>
                <el-form-item label="运费金额" prop="ShipAmount" >
                    <el-input-number v-model="formData.ShipAmount" :precision="2" :step="0.1"></el-input-number>
                </el-form-item>
                <el-form-item label="打包费" prop="PackAmount" >
                    <el-input-number v-model="formData.PackAmount" :precision="2" :step="0.1"></el-input-number>
                </el-form-item>
                <el-form-item label="级别数序">
                    <el-input-number v-model="formData.LevelNum" disabled></el-input-number>
                </el-form-item>
            </el-form>
            <div class="dialog-footer">
                <el-button @click="cancel()">关闭</el-button>
                <el-button class="btn-primary" @click="submitLevelForm">提交</el-button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['setId', 'count'],
    name: '',
    data() {
        return {
            formData: {
                SetId: '',
                SizeName: '',
                LevelNum: 1,
                PackAmount: 0,
                ShipAmount: 0
            },
            rules: {
                SizeName: [
                    {
                        required: true,
                        message: 'ShipAmount属性名称必填',
                        trigger: 'blur'
                    }
                ],
                ShipAmount: [
                    {
                        required: true,
                        message: '运费金额必填（必须为数字类型）',
                        trigger: 'blur'
                    }
                ],
                PackAmount: [
                    {
                        required: true,
                        message: '打包费必填（必须为数字类型）',
                        trigger: 'blur'
                    }
                ]
            }
        };
    },
    mounted() {
        if (this.setId) {
            this.formData.SetId = this.setId;
            this.getLevelInfo();
        }
        if (+this.count) {
            this.formData.LevelNum = +this.count + 1;
        }
    },
    methods: {
        getLevelInfo() {
            let url = '/api/EntpInfoManagement/GetGoodsPackSizeSetById';
            this.$util
                .axiosGet({
                    url: url,
                    data: {
                        SetId: this.formData.SetId
                    }
                })
                .then(res => {
                    if (res.data) {
                        this.formData.SizeName = res.data.SizeName;
                        this.formData.LevelNum = res.data.LevelNum;
                        this.formData.PackAmount = res.data.PackAmount;
                        this.formData.ShipAmount = res.data.ShipAmount;
                    }
                })
                .catch(() => {});
        },
        // 提交表单
        submitLevelForm() {
            let that = this;
            that.$refs.formData.validate(valid => {
                if (valid) {
                    let url = '/api/EntpInfoManagement/SubmitGoodsPackSizeSet';
                    that.$util
                        .axiosPost({
                            url: url,
                            data: that.formData
                        })
                        .then(() => {
                            that.$util.successMsg('成功提交商品运输成本属性');
                            that.$emit('closeDialog', true);
                        })
                        .catch(() => {});
                } else {
                    this.$util.errorMsg('校验不通过');
                    return false;
                }
            });
        },
        cancel() {
            this.$emit('closeDialog');
        }
    }
};
</script>
<style lang="less" scoped>
.form-value {
    border-radius: 4px;
    border: 1px solid #dcdfe6;
    color: #606266;
    height: 40px;
    line-height: 40px;
    padding: 0 15px;
    width: 100%;
}
.form-column {
    width: 33.33%;
}
.dialog-footer {
    text-align: right;
}
</style>
